import { BybitWalletChain } from '@/types/walletType';
import { create } from 'zustand';
import { CurrentWallet } from '@/types/walletType';

interface StoreState {
  activityChainInfo: BybitWalletChain | CurrentWallet | null;
}

type Action = {
  setActivityChainInfo: (info: BybitWalletChain | CurrentWallet | null) => void;
};

const useStore = create<StoreState & Action>()(
  (
    set
    // get
  ) => ({
    activityChainInfo: null,
    setActivityChainInfo: (info: BybitWalletChain | CurrentWallet | null) => {
      set(() => ({ activityChainInfo: info }));
    },
  })
);

export default useStore;
